"use client";

import { c as _c } from "react/compiler-runtime";
import { FiUsers } from "react-icons/fi";
import { TbClipboardList, TbPackage } from "react-icons/tb";
import { formatCurrency, formatToHumanReadable } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
import { DiscountTemplate } from "@/types/billing/discount";
export interface CatalogSearchItem {
  _kind: "catalog";
  id: string;
  name: string;
  price: number;
  type: string;
  taxable?: boolean;
  /** For packages: the package's contents (non-archived discount templates). */
  discountTemplates?: DiscountTemplate[];
}
interface ItemDisplayProps {
  item: CatalogSearchItem;
  showPrice?: boolean;
  showTaxStatus?: boolean;
  showItemType?: boolean;
  className?: string;
  nameClassName?: string;
}
function getItemIcon(type: string) {
  switch (type) {
    case "SERVICE":
      return <TbClipboardList className="mr-2 h-4 w-4 shrink-0 opacity-50" />;
    case "MEMBERSHIP":
      return <FiUsers className="mr-2 h-4 w-4 shrink-0 opacity-50" />;
    default:
      return <TbPackage className="mr-2 h-4 w-4 shrink-0 opacity-50" />;
  }
}
export default function ItemDisplay(t0) {
  const $ = _c(29);
  const {
    item,
    showPrice: t1,
    showTaxStatus: t2,
    showItemType: t3,
    className,
    nameClassName
  } = t0;
  const showPrice = t1 === undefined ? true : t1;
  const showTaxStatus = t2 === undefined ? true : t2;
  const showItemType = t3 === undefined ? true : t3;
  let infoSegments;
  if ($[0] !== item.price || $[1] !== item.taxable || $[2] !== item.type || $[3] !== showItemType || $[4] !== showPrice || $[5] !== showTaxStatus) {
    infoSegments = [];
    if (showItemType) {
      let t4;
      if ($[7] !== item.type) {
        t4 = formatToHumanReadable(item.type);
        $[7] = item.type;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      infoSegments.push(t4);
    }
    if (showPrice) {
      let t4;
      if ($[9] !== item.price) {
        t4 = formatCurrency(item.price);
        $[9] = item.price;
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      infoSegments.push(t4);
    }
    if (showTaxStatus && item.taxable !== undefined) {
      infoSegments.push(item.taxable ? "Taxable" : "Tax exempt");
    }
    $[0] = item.price;
    $[1] = item.taxable;
    $[2] = item.type;
    $[3] = showItemType;
    $[4] = showPrice;
    $[5] = showTaxStatus;
    $[6] = infoSegments;
  } else {
    infoSegments = $[6];
  }
  let t4;
  if ($[11] !== className) {
    t4 = cx("flex w-full items-center", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== item.type) {
    t5 = getItemIcon(item.type);
    $[13] = item.type;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== nameClassName) {
    t6 = cx("font-semibold text-foreground", nameClassName);
    $[15] = nameClassName;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== item.name || $[18] !== t6) {
    t7 = <div className="mr-4 flex flex-row items-center"><span className={t6}>{item.name}</span></div>;
    $[17] = item.name;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== infoSegments) {
    t8 = <span className="flex items-center text-right text-caption text-foreground-secondary">{infoSegments.map(_temp)}</span>;
    $[20] = infoSegments;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <span className="flex w-full flex-row items-center justify-between">{t7}{t8}</span>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t4 || $[26] !== t5 || $[27] !== t9) {
    t10 = <div className={t4}>{t5}{t9}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(segment, index) {
  return <span key={index} className="flex items-center whitespace-nowrap">{index > 0 && <span className="mx-1 text-foreground-secondary">•</span>}<span>{segment}</span></span>;
}